import React, { useEffect, useMemo, useState } from 'react';

import { useTranslation } from 'react-i18next';

import {

    HERO_MEDIA_MODE,

    HERO_SLIDES,

    getHeroImageUrl,

    getHeroVideoSources,

} from '../config/landingHeroMedia';



const INTERVAL_MS = 6000;



function useWebBreakpoint() {

    const [bp, setBp] = useState('web');

    useEffect(() => {

        const mqTablet = window.matchMedia('(max-width: 1023px)');

        const mqMobile = window.matchMedia('(max-width: 767px)');

        const update = () => {

            if (mqMobile.matches) setBp('webMobile');

            else if (mqTablet.matches) setBp('webTablet');

            else setBp('web');

        };

        update();

        mqTablet.addEventListener('change', update);

        mqMobile.addEventListener('change', update);

        return () => {

            mqTablet.removeEventListener('change', update);

            mqMobile.removeEventListener('change', update);

        };

    }, []);

    return bp;

}



/** ─── Режим: фото (по умолчанию) ─── */

function HeroImageSlides({ slides, active, breakpoint }) {

    const [urls, setUrls] = useState(() =>

        slides.map((s) => getHeroImageUrl(s.key, breakpoint))

    );



    useEffect(() => {

        const next = slides.map((s) => getHeroImageUrl(s.key, breakpoint));

        setUrls(next);

        slides.forEach((slide, i) => {

            const primary = next[i];

            const fallback = getHeroImageUrl(slide.key, 'web');

            const img = new Image();

            img.onerror = () => {

                if (primary !== fallback) {

                    setUrls((prev) => {

                        const copy = [...prev];

                        copy[i] = fallback;

                        return copy;

                    });

                }

            };

            img.src = primary;

        });

    }, [slides, breakpoint]);



    return slides.map((slide, i) => (

        <div

            key={slide.key}

            className={`sp-hero-bg__slide${i === active ? ' sp-hero-bg__slide--active' : ''}`}

            style={{ backgroundImage: `url(${urls[i]})` }}

        />

    ));

}



/** ─── Режим: видео — раскомментируйте использование внизу + HERO_MEDIA_MODE = 'video' ─── */

function HeroVideoSlides({ slides, active, breakpoint }) {

    return slides.map((slide, i) => {

        const src = getHeroVideoSources(slide.key, breakpoint);

        const isActive = i === active;

        return (

            <video

                key={slide.key}

                className={`sp-hero-bg__video${isActive ? ' sp-hero-bg__video--active' : ''}`}

                autoPlay

                muted

                loop

                playsInline

                poster={src.poster}

                aria-hidden

            >

                <source src={src.mp4} type="video/mp4" />

                {/* <source src={src.webm} type="video/webm" /> */}

            </video>

        );

    });

}



/**

 * Фон главной и страниц входа/регистрации.

 * Медиа: media/landing-hero/ → sync-media-assets.js → public/

 * @param {'landing'|'auth'} variant

 */

export default function LandingHeroBackground({ variant = 'landing' }) {

    const { t } = useTranslation('landing');

    const breakpoint = useWebBreakpoint();

    const slides = useMemo(

        () => HERO_SLIDES.map((s) => ({

            key: s.key,

            alt: t(`heroSlides.${s.key}`),

        })),

        [t]

    );

    const [active, setActive] = useState(0);



    useEffect(() => {

        const id = setInterval(() => {

            setActive((i) => (i + 1) % slides.length);

        }, INTERVAL_MS);

        return () => clearInterval(id);

    }, [slides.length]);



    const overlayClass = variant === 'auth'

        ? 'sp-hero-bg__overlay sp-hero-bg__overlay--auth'

        : 'sp-hero-bg__overlay sp-hero-bg__overlay--landing';



    const useVideo = HERO_MEDIA_MODE === 'video';



    return (

        <div className="sp-hero-bg" aria-hidden="true">

            {useVideo ? (

                <HeroVideoSlides slides={slides} active={active} breakpoint={breakpoint} />

            ) : (

                <HeroImageSlides slides={slides} active={active} breakpoint={breakpoint} />

            )}

            <div className={overlayClass} />

            <div className="sp-hero-bg__dots">

                {slides.map((_, i) => (

                    <span

                        key={i}

                        className={`sp-hero-bg__dot${i === active ? ' sp-hero-bg__dot--active' : ''}`}

                    />

                ))}

            </div>

        </div>

    );

}


